var MDB = window.MDB = window.MDB || {};
MDB.Roles = MDB.Roles || {};

$.extend(MDB.Roles, {
    _allPermissions: [],
    
    _getPermissions: function(isEditAction) {
        return isEditAction ? MDB.Roles._getSelectablePermissions() : MDB.Roles._allPermissions;
    },
    _getSelectablePermissions: function() {
        var availablePermissions = MDB.Roles._allPermissions;
        
        var grid = MDB.Roles._grid.data('kendoGrid');
        if(grid){
            var selectedPermissions = _.map(grid.dataSource.data(), 'PermissionId');
            availablePermissions = _.filter(availablePermissions, function(ap){
                return selectedPermissions.indexOf(ap.id) === -1; 
            });
        }
        
        return availablePermissions;
    },
    _getPermissionIds: function(isEditAction){
        return _.map(MDB.Roles._getPermissions(isEditAction), 'id');
    },
    _getPermissionDisplayName: function(permissionId){
        if(!permissionId) {
            return;
        }
        
        var permissions = MDB.Roles._getPermissions(false);
        return _.find(permissions, {'id': permissionId}).name;
    },
    boot: function (opts) {
        var grid = $('#grid');
        
        $('#DashboardIds').kendoMultiSelect({autoClose: false});
        
        if(grid.length){
            MDB.Roles.initializePermissionsEditor(grid, opts);
        }        
    },
    initializePermissionsEditor: function(grid, opts){
        var canWrite = opts.canEdit || false;
        var canDelete = opts.canDelete || false;
        var roleId = opts.id;

        var builder = MDB.KendoConfigBuilder;
        var crudServiceBaseUrl = '/api/Roles/';
        var permissionSelector = $('#all-permissions');

        MDB.Roles._grid = grid;

        MDB.Roles._allPermissions = _.map(permissionSelector.find('option'), function(opt){
            return {
                name: opt.innerHTML,
                id:opt.value
            }
        });

        var transportOpts = {
            read: function (options) {
                var params = '?' + $.param({ id: roleId });
                builder.dataSourceTransportFunction(crudServiceBaseUrl + params, 'GET', options);
            }
        };

        var columnDefinitions = [{
            field: 'PermissionId',
            title: MDB.loadResourceString('PermissionPerRoleModel_PermissionId_DisplayName'),
            template: function (item) {
                return MDB.Roles._getPermissionDisplayName(item.PermissionId); 
            },
            editor: function (e, opts) {
                var availablePermissions = MDB.Roles._getPermissionIds(true);

                //Ensure current permission is still selectable
                if(!opts.model.isNew()) {
                    availablePermissions.push(opts.model.PermissionId);
                }

                var selectablePermissions = _.filter(permissionSelector.find('option'), function (opt) {
                    return availablePermissions.indexOf(opt.value) !== -1;
                });

                return builder.gridDropdownEditor(e, opts.field, selectablePermissions, {
                    filter: "contains"
                }, opts);
            },
            sortable: {
                compare: function(itemLeft, itemRight){
                    //https://stackoverflow.com/a/23769681
                    return MDB.Roles._getPermissionDisplayName(itemLeft.PermissionId) > MDB.Roles._getPermissionDisplayName(itemRight.PermissionId);
                },
                initialDirection: 'asc'
            }
        }, {
            field: 'CanRead',
            title: MDB.loadResourceString('PermissionPerRoleModel_CanRead_DisplayName'),
            template: builder.gridBooleanYesNoTemplate('CanRead'),
            editor: builder.gridCheckboxEditor
        }, {
            field: 'CanWrite',
            title: MDB.loadResourceString('PermissionPerRoleModel_CanWrite_DisplayName'),
            template: builder.gridBooleanYesNoTemplate('CanWrite'),
            editor: builder.gridCheckboxEditor
        }, {
            field: 'CanDelete',
            title: MDB.loadResourceString('PermissionPerRoleModel_CanDelete_DisplayName'),
            template: builder.gridBooleanYesNoTemplate('CanDelete'),
            editor: builder.gridCheckboxEditor
        },{
            field: 'CanSeeInMenu',
            title: MDB.loadResourceString('PermissionPerRoleModel_CanSeeInMenu_DisplayName'),
            template: builder.gridBooleanYesNoTemplate('CanSeeInMenu'),
            editor: builder.gridCheckboxEditor
        }
        ];

        var commandColumns = [];

        if(canWrite){
            transportOpts.create = function (options) {
                builder.dataSourceTransportFunction(crudServiceBaseUrl, 'POST', options);
            };

            transportOpts.update = function (options) {
                builder.dataSourceTransportFunction(crudServiceBaseUrl, 'PUT', options);
            };

            commandColumns.push('edit');
        }

        if(canDelete){
            transportOpts.destroy = function (options) {
                var params = '?' + $.param({id: roleId,  permissionId: options.data.PermissionId });
                builder.dataSourceTransportFunction(crudServiceBaseUrl + params, 'DELETE', options);
            };

            commandColumns.push('destroy');
        }

        if(commandColumns.length) {
            columnDefinitions.push(MDB.KendoConfigBuilder.gridCommandColumn(commandColumns));
        }


        var gridConfig = {
            autoBind: true,
            dataSource: new kendo.data.DataSource({
                transport: transportOpts,
                pageSize: 20,
                schema: {
                    model: {
                        id: 'PermissionId',
                        fields: {
                            PermissionId: {  },
                            RoleId: { editable: false, defaultValue: roleId },
                            OriginalPermissionId: { nullable: false, editable: false, defaultValue: '00000000-0000-0000-0000-000000000000' },
                            CanRead: { type: 'boolean', editable: canWrite },
                            CanWrite: { type: 'boolean', editable: canWrite },
                            CanDelete: { type: 'boolean', editable: canWrite },
                            CanSeeInMenu: { type: 'boolean', editable: canWrite, defaultValue: true }
                        }
                    }
                },
                error: function (e) {
                    this.cancelChanges();
                    MDB.alert(builder.getWebApiErrorsMessage(e))
                }
            }),
            columnMenu: true,
            pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
            columns: columnDefinitions,
            sortable: true,
            messages: {
                commands: builder.commandLabels(),
                noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
            }
        };

        if(canWrite){
            gridConfig.toolbar = ['create'];
            gridConfig.editable = 'inline';
        } else{
            //Grid still needs to be 'editable' to allow delete operations
            gridConfig.editable = canDelete;
        }

        grid.kendoGrid(gridConfig);
    }
});